import { createContext, useContext } from 'react';
import type { CatalogItem, GetReleaseKitResponse, ReleasePlan } from '../../../../../../redux/api/fymAPI.types';
import type { SerializedSocialChannel } from '../../../types';
import type { DraftFit } from './rolloutModel';
import type { RolloutActions } from './useRolloutActions';

/** What every part of the run sheet reads (design rollout-plan a1–e1). One provider: `RolloutRunSheet`. */
export interface RolloutContextValue {
  accountId: number;
  item: CatalogItem;
  release: GetReleaseKitResponse;
  plan: ReleasePlan;
  /** `YYYY-MM-DD` of today in the artist's time zone (the viewer's zone when none is stored). */
  today: string;
  timeZone: string | null;
  /** The usable channels (connected and manual) and their rows. */
  channels: SerializedSocialChannel[];
  actions: RolloutActions;
  /** False for the demo artist: the plan is read only. */
  canAct: boolean;
  /** The video credits left (plan plus packs); null when not known. */
  creditsLeft: number | null;
  /** The fit of each draft in its month (Free plan, owner decision 8), by post uuid. */
  fits: ReadonlyMap<string, DraftFit>;
  /** Opens the step sheet (frame c1) on a step, and on a channel tab. */
  openStep: (key: string, platform?: string) => void;
  openStepKey: string | null;
}

export const RolloutContext = createContext<RolloutContextValue | null>(null);

export function useRollout(): RolloutContextValue {
  const value = useContext(RolloutContext);
  if (value === null) {
    throw new Error('useRollout is used outside RolloutRunSheet');
  }
  return value;
}
